/**
 * Formatea un número como moneda CLP (Chilean Peso)
 * Incluye separador de miles (.) y sin decimales
 *
 * @param amount - Monto a formatear
 * @returns String formateado: "$1.500" o "$50.000"
 *
 * @example
 * formatCurrency(1500) // "$1.500"
 * formatCurrency(50000) // "$50.000"
 * formatCurrency(1234567.89) // "$1.234.568" (redondea a entero)
 */
export function formatCurrency(amount: number): string {
  const rounded = Math.round(amount)
  return `$${rounded.toLocaleString('es-CL', { maximumFractionDigits: 0 })}`
}

/**
 * Formatea un número como cantidad sin signo de pesos
 * Incluye separador de miles (.) y sin decimales
 *
 * @param amount - Monto a formatear
 * @returns String formateado: "1.500" o "50.000"
 *
 * @example
 * formatAmount(1500) // "1.500"
 * formatAmount(50000) // "50.000"
 */
export function formatAmount(amount: number): string {
  const rounded = Math.round(amount)
  return rounded.toLocaleString('es-CL', { maximumFractionDigits: 0 })
}
